export * from './quiz-details';
